import { openDB } from "idb";

export const openBlogDB = async () => {
  const db = await openDB("blogsDB", 1, {
    upgrade(db) {
      db.createObjectStore("blogs", { keyPath: "id" });
    },
  });
  return db;
};

export const saveBlogsToDB = async (blogs: any[]) => {
  const db = await openBlogDB();
  const tx = db.transaction("blogs", "readwrite");
  const store = tx.objectStore("blogs");

  blogs.forEach((blog) => store.put(blog));
  await tx.done;
};

export const getBlogsFromDB = async () => {
  const db = await openBlogDB();
  const tx = db.transaction("blogs", "readonly");
  const store = tx.objectStore("blogs");
  return store.getAll();
};
